import './Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-image-container">
        <img 
          src="/assets/images/hero-image.jpg" 
          alt="Mountain landscape with car" 
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        <div className="container">
          <h1 className="hero-title fade-in">
            Mountain-Ready Rental Cars<br />
            for the Tahoe Region and Beyond
          </h1>
          <p className="hero-subtitle fade-in" style={{ animationDelay: '0.2s' }}>
            Fun, capable vehicles ready for your Sierra adventure
          </p>
          <a 
            href="#inventory" 
            className="btn hero-cta fade-in"
            style={{ animationDelay: '0.4s' }}
          >
            View Inventory
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
